import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { PlayerService } from './player.service';

declare var Module: any;
declare var window: any;
declare var WebAssembly: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  engineRunning = false;
  source;
  processor;
  context = new ((<any>window).AudioContext || (<any>window).webkitAudioContext)();
  audioPtrLeft;
  audioPtrRight;
  loading = true;
  motor = 'stop';
  position = 0;
  RPM = 0;
  POWER_ON = false;
  PLAY = false;
  chosen_rpm = 33;
  play_interval;
  isAndroid;
  warning = true;
  isFirefox = false;
  @ViewChild('modal') modal: ElementRef;

  constructor(private playerService: PlayerService, private renderer: Renderer2) {

    this.playerService.needleDown.subscribe((needle) => {
      Module._setNeedleDown(needle);
    });

    this.playerService.position.subscribe((pos) => {
      Module._setPosition(pos);
    });

    this.playerService.speed.subscribe((speed) => {
      Module._setSpeed(speed[0], speed[1]);
    });

    this.playerService.new_audio.subscribe((audio) => {
      // console.log('new audio loaded');
    });

    this.playerService.end_of_song.subscribe((audio) => {
      // console.log('end of song');
      this.stop();
    });

    Module.onRuntimeInitialized = () => {
      console.log('runtime initialized');
      this.loadAndPopulate('/assets/nes.mp3');
    };
  }

  ngOnInit() {
    this.isAndroid = /(android)/i.test(navigator.userAgent);
    this.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    const supported = (() => {
      try {
          if (typeof WebAssembly === 'object'
              && typeof WebAssembly.instantiate === 'function') {
              const module = new WebAssembly.Module(Uint8Array.of(0x0, 0x61, 0x73, 0x6d, 0x01, 0x00, 0x00, 0x00));
              if (module instanceof WebAssembly.Module)
                  return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
          }
      } catch (e) {
      }
      return false;
    })();
    if (this.isAndroid || !supported || this.isFirefox ) {
      this.renderer.setStyle(this.modal.nativeElement, 'display', 'initial');
      this.warning = false;
    }
  }

  musicReady() {
      Module._setWearGain(0.9);
      Module._setHumGain(0.25);
      Module._setNoiseGain(0.1);
      Module._setInputGain(0.5);
      Module._setScratchesFrequency(0.5);
      Module._setAmpQuality(0.75);
      Module._setPinQuality(0.75);
      Module._setCableQuality(0.95);
      Module._setHumFrequency(1);
      console.log('rock on!');
      this.loading = false;
  }

  resumeAudio() {
    this.context.resume();
  }

  play() {
    if (this.POWER_ON === false) {
      this.power_on();
    }
    this.changeRPM(this.chosen_rpm);
    this.playerService.play_record();
    this.PLAY = true;
  }

  power_on() {
      this.POWER_ON = true;
      this.RPM = 0;
      this.context.resume();
      if (!this.engineRunning) {
        this.startAudio();
        this.engineRunning = true;
      }
  }

  power_off() {
    this.stop();
    this.PLAY = false;
    this.context.suspend();
  }

  stop() {
    this.PLAY = false;
    this.RPM = 0;
    Module._setSpeed(0, 0.2);
    this.playerService.stop_record();
    clearInterval(this.play_interval);
  }

  armInPlace($event) {
    Module._setNeedleDown(true);
  }

  motorChange(motor) {
    if (motor === 'playstop') {
      if (this.PLAY) {
        this.stop();
        this.PLAY = false;
      } else {
        this.play();
        this.PLAY = true;
      }
    } else if (motor === 'start') {
      if (!this.POWER_ON) {
        this.power_on();
        this.POWER_ON = true;
      } else {
        this.power_off();
        this.POWER_ON = false;
      }
    }
  }

  arm_up(event) {
    Module._setNeedleDown(false);
  }

  arm_down(event) {
    Module._setNeedleDown(true);
  }

  arm_in_place(event) {
    Module._setNeedleDown(true);
  }

  arm_moved(event) {
    Module._setPosition(event);
  }

  armMovedtoStart(event) {
    Module._setPosition(0);
    this.position = 0;
    Module._setNeedleDown(false);
  }

  setRPM(rpm) {
    this.playerService.setRPM(rpm);
    this.chosen_rpm = rpm;
    if (this.PLAY) {
      this.changeRPM(rpm);
    }
  }

  changeRPM(rpm) {
    if (this.chosen_rpm === 33) {
      Module._setSpeed(1, 0.2);
      this.RPM = 33;
    } else {
      Module._setSpeed(1.363636, 0.2);
      this.RPM = 45;
    }
  }

  setWear(event) {
    Module._setWearGain(event / 100);
  }

  setHum(event) {
    Module._setHumGain(event / 100);
  }

  setInput(event) {
    Module._setInputGain(event / 100);
  }

  setNoise(event) {
    Module._setNoiseGain(event / 100);
  }

  setScratch(event) {
    Module._setScratchesFrequency(event);
  }

  setAmp(event) {
    Module._setAmpQuality(event);
  }

  setPin(event) {
    Module._setPinQuality(event);
  }

  setCable(event) {
    Module._setCableQuality(event);
  }

  setHumHz(event) {
    if (!this.loading) {
      if (event === 50) {
        Module._setHumFrequency(1);
      }
      if (event === 60) {
        Module._setHumFrequency(0);
      }
    }
  }

  newSong(file) {
    this.stop();
    this.loading = true;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(file);
    fileReader.onload = ((song) => {
      this.decodeMp3BytesFromArrayBuffer(fileReader.result);
      console.log('LOADING NEW AUDIO');
      this.playerService.newAudio();
      Module._setPosition(0);
      this.loading = false;
    });
  }

  loadAndPopulate(url) {
    console.log('load and populate');
    const req = new XMLHttpRequest();
    req.open('GET', url, true);
    req.responseType = 'arraybuffer';

    req.onload = () => {
        this.decodeMp3BytesFromArrayBuffer(req.response);
        this.musicReady();
    };

    req.send();
  }
  obtainMp3BytesInArrayBufferUsingFileAPI(selectedFile, callback) {

    const reader = new FileReader();
    reader.onload = function (ev) {
        // The FileReader returns us the bytes from the computer's file system as an ArrayBuffer
        const mp3BytesAsArrayBuffer = reader.result;
        callback(mp3BytesAsArrayBuffer);
    };
    reader.readAsArrayBuffer(selectedFile);
}

decodeMp3BytesFromArrayBuffer(mp3BytesAsArrayBuffer) {

  // The AudioContext will asynchronously decode the bytes in the ArrayBuffer for us and return us
  // the decoded samples in an AudioBuffer object.
  // const audioContext = new ((<any>window).AudioContext || (<any>window).webkitAudioContext)();
  this.context.decodeAudioData(mp3BytesAsArrayBuffer, function (decodedSamplesAsAudioBuffer) {
      const samplerate = decodedSamplesAsAudioBuffer.sampleRate;
      const numFrames = decodedSamplesAsAudioBuffer.length;
      const numChannels = decodedSamplesAsAudioBuffer.numberOfChannels;
      const arrayLeft = decodedSamplesAsAudioBuffer.getChannelData(0);
      const arrayRight = decodedSamplesAsAudioBuffer.getChannelData(1);
      Module._freeAudioData();
      const audioPtr1 = Module._mymalloc(numFrames * 4);
      const audioPtr2 = Module._mymalloc(numFrames * 4);
      for (let i = 0; i < numFrames; i++) {
      Module.HEAPF32[audioPtr1 / 4 + i] = arrayLeft[i];
      Module.HEAPF32[audioPtr2 / 4 + i] = arrayRight[i];
      }


      Module._setAudioData(audioPtr1, audioPtr2, numFrames);
  });
}

openAudioFile() {
  // I've added two basic validation checks here, but in a real world use case you'd probably be a little more stringient.
  // Be aware that Firefox uses 'audio/mpeg' as the MP3 MIME type, Chrome uses 'audio/mp3'.
  const fileInput = document.forms[0].mp3FileSelect;
  if (fileInput.files.length > 0 && ['audio/mpeg', 'audio/mp3'].includes(fileInput.files[0].type)) {
      // We're using the File API to obtain the MP3 bytes, here but they could also come from an XMLHttpRequest
      // object that has downloaded an MP3 file from the internet, or any other ArrayBuffer containing MP3 data.
      this.obtainMp3BytesInArrayBufferUsingFileAPI(fileInput.files[0], function (mp3BytesAsArrayBuffer) {
          // Pass the ArrayBuffer to the decode method
          this.decodeMp3BytesFromArrayBuffer(mp3BytesAsArrayBuffer);
      });
  } else { alert('Error! No attached file or attached file was of the wrong type!'); }
}

startAudio() {
  console.log('start audio');
  // malloca en buffer..
  this.audioPtrLeft = Module._mymalloc(4096 * 4);
  this.audioPtrRight = Module._mymalloc(4096 * 4);

  this.source = this.context.createBufferSource();
  this.processor = this.context.createScriptProcessor(2048);
  this.processor.onaudioprocess = ((e) => {
    // polla ner audiodatan till mallocad buffer. (interleaved data)
    Module._processBlock(this.audioPtrLeft, this.audioPtrRight, 2048);
    const leftOut = e.outputBuffer.getChannelData(0);
    const rightOut = e.outputBuffer.getChannelData(1);
    for (let i = 0; i < leftOut.length; i++) {
      leftOut[i] = Module.HEAPF32[this.audioPtrLeft / 4 + i];
      rightOut[i] = Module.HEAPF32[this.audioPtrRight / 4 + i];
    }
  });
  this.processor.connect(this.context.destination);
  this.source[this.source.start ? 'start' : 'noteOn'](0);
}

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts